import queryString from 'query-string';

export function addSearchParams(customDataPoints) {
  let search = '';

  if (customDataPoints.length > 0) {
    search = `&data_points=${customDataPoints.join(',')}`;
  }

  return search;
}

export function getDataPointsFromUrlParams(search) {
  const params = queryString.parse(search);
  let { data_points = [] } = params;

  if (!data_points || !params) {
    data_points = [];
    return data_points;
  }

  if (data_points.length) {
    data_points = data_points.split(',');
  }

  return data_points;
}
